import AbstractStonecodeFileTypeSourceModel from './AbstractStonecodeFileTypeSourceModel';

export default class StonecodeFileTypeSourceModel extends AbstractStonecodeFileTypeSourceModel {}
